export enum HeaderMode {
  Scorecards = 'Scorecards',
  OKRs = 'OKRs',
}
